let currentOrientation = 'hojrevendt';
let currentProduct = '';
let customer = 'MHMWERENBERGDK';
let lastSelectedColor;

function dataValueFormatter(input) {
    return input
        .toLowerCase() // Convert to lowercase
        .replace(/ø/g, 'o') // Replace 'ø' with 'o'
        .replace(/å/g, 'a') // Replace 'å' with 'a'
        .replace(/æ/g, 'ae') // Replace 'æ' with 'ae'
        .replace(/[^\w\s-]/g, '') // Remove characters that are not letters, numbers, spaces, or hyphens
        .replace(/\s+/g, '-') // Replace multiple spaces with a single hyphen
        .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
        .replace(/^-|-$/g, ''); // Remove leading or trailing hyphens
}

// Wait for the mazingProjectAvailable function to become available
const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50; // Check every 50ms
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});


// Main script logic
const initializeScript = async () => {
    await waitForMazingFunction;

    console.log('mazingProjectAvailable is now available');

    // Call mazingProjectAvailable to get the iframe source URL
    const iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: () => {

            const url = window.location.href;
            const match = url.match(/\/products\/([^?]+)/);
            currentProduct = match ? match[1] : null;
            console.log('extracted sku: ' + currentProduct);

            let orientationSelector = document.querySelector('input[type="radio"][value="Højrevendt"]');
            currentOrientation = orientationSelector ? (orientationSelector.checked ? 'hojrevendt' : 'venstrevendt') : '';
            return currentOrientation ? `${currentProduct}-${currentOrientation}` : currentProduct;
        }
    });

    if (!iframeSrc) {
        console.error('No project URL returned by mazingProjectAvailable');
        return; // Exit the script if no URL is returned
    }

    console.log('Received iframeSrc:', iframeSrc);

    // Configurable "wished index" for the new thumbnail
    const wishedIndex = 0; // For example, place it at the first position (index 0)

    // Select the element with the class 'product__main-photos'
    const mainPhotosElement = document.querySelector('.product__main-photos');

    // Define the iframe element
    let iframeElement;

    if (mainPhotosElement) {
        // Create the iframe and style it
        iframeElement = document.createElement('iframe');
        iframeElement.style.cssText = "border: 0; height: 100%; left: 0; position: absolute;  top: 0; width: 100%; background: white; display: none; padding-left: 22px;"; // max-height: 600px;
        iframeElement.src = iframeSrc;
        iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";
        iframeElement.allowFullscreen = true;
        iframeElement.setAttribute('allowusermedia', '');
        iframeElement.id = 'mazing-iframe';

        // Append the iframe to the main photos element
        mainPhotosElement.appendChild(iframeElement);
    } else {
        console.error('Element with class "product__main-photos" not found.');
        return;
    }

    // Select the element with the class 'product__thumbs--scroller'
    const scrollerElement = document.querySelector('.product__thumbs--scroller');

    // Create a new div element to hold your content
    const newThumbItem = document.createElement('div');
    newThumbItem.className = 'product__thumb-item';
    newThumbItem.setAttribute('data-index', 'none');

    // Add inner HTML content to the new div
    const imgElement = document.createElement('img');
    imgElement.src = 'https://magelig.dk/cdn/shop/t/24/assets/mazing-icon.png';
    // https://magelig.dk/cdn/shop/t/24/assets/mazing-icon.svg?v=123886368925112251581733170078
    imgElement.alt = '3D Image';
    imgElement.width = 720;
    imgElement.height = 720;
    imgElement.loading = 'eager';
    imgElement.className = 'image-element';
    imgElement.style.sizes = '(min-width: 769px) 100vh, 100vw';
    imgElement.style.boxShadow = ''; // Initially no box-shadow
    imgElement.style.padding = '2px'; // Add padding
    imgElement.style.objectFit = 'contain';
    imgElement.style.cursor = 'pointer';

    const imageWrap = document.createElement('div');
    imageWrap.className = 'image-wrap image-wrap__thumbnail loaded';
    imageWrap.style.cssText = 'height: 0; padding-bottom: 100.0%;';
    imageWrap.appendChild(imgElement);

    newThumbItem.appendChild(imageWrap);

    // Add a click event listener to show the iframe when this specific thumbnail is clicked
    newThumbItem.addEventListener('click', (event) => {
        if (iframeElement) {
            iframeElement.style.display = 'block';
        } else {
            console.error('Iframe element is not available.');
        }

        // Remove the class 'is-active' and the box-shadow from all other thumbnails
        document.querySelectorAll('.product__thumb-item').forEach((thumbItem) => {
            thumbItem.querySelector('img')?.style.removeProperty('box-shadow');
        });

        // Add the box-shadow to the clicked thumbnail
        imgElement.style.boxShadow = 'inset 0 0 0 2px var(--colorTextBody)';

        // Remove the class 'is-active' from all a elements with 'product__thumb' class after 100ms
        setTimeout(() => {
            document.querySelectorAll('a.product__thumb.is-active').forEach((activeThumb) => {
                activeThumb.classList.remove('is-active');
            });
        }, 100);

        // Prevent hiding the iframe when this specific element is clicked
        event.stopPropagation();
    });

    // Add the new thumbnail at the wished index
    if (scrollerElement) {
        const children = scrollerElement.children;

        if (wishedIndex >= 0 && wishedIndex < children.length) {
            // Insert the new thumbnail at the wished index
            scrollerElement.insertBefore(newThumbItem, children[wishedIndex]);
        } else {
            // Append the new thumbnail at the end if the wished index is out of bounds
            scrollerElement.appendChild(newThumbItem);
        }
    } else {
        console.error('Element with class "product__thumbs--scroller" not found.');
        return;
    }

    // Add event listeners to all other elements with class 'product__thumb-item'
    document.querySelectorAll('.product__thumb-item').forEach((thumbItem) => {
        // Skip adding the listener to the newly created item
        if (thumbItem !== newThumbItem) {
            thumbItem.addEventListener('click', () => {
                if (iframeElement) {
                    iframeElement.style.display = 'none';
                }
                // Remove the box-shadow from the newThumbItem image
                imgElement.style.removeProperty('box-shadow');
            });
        }
    });

    // Automatically trigger a click on the newThumbItem only if index = 0
    if (wishedIndex === 0) {
        setTimeout(() => {
            newThumbItem.click();
        }, 0);
    }


    const operations = document.querySelectorAll('.variant-input');


    for(let i=0; i < operations.length; i++) {

        const operation = operations[i];
        const newDataValue = dataValueFormatter(operation.getAttribute('data-value'));

        operation.addEventListener('click', () => {

            console.log('clicked variant', newDataValue);


            if(newDataValue === 'hojrevendt' || newDataValue === 'venstrevendt'){
                currentOrientation = newDataValue;
                iframeElement.src = 'https://mazing.link/' + customer + '/' + currentProduct + '-' + currentOrientation;

                if(lastSelectedColor) {
                    setTimeout(() => {
                        iframeElement.contentWindow.postMessage({
                            type: 'SWITCH_VARIANT',
                            value: {
                                trigger: lastSelectedColor
                            }
                        }, '*');
                    }, 2000);
                }
            } else {
                lastSelectedColor = newDataValue;
                iframeElement.contentWindow.postMessage({
                    type: 'SWITCH_VARIANT',
                    value: {
                        trigger: newDataValue
                    }
                }, '*');
            }
        });
    }

    const thumbsVisibilityAdd = document.querySelector('.product__thumbs');
    // Remove the 'medium-up--hide' class if it exists
    if (thumbsVisibilityAdd && thumbsVisibilityAdd.classList.contains('medium-up--hide')) {
        thumbsVisibilityAdd.classList.remove('medium-up--hide');
    }

    const mobileThumbs = document.querySelector('ol.flickity-page-dots');
    // Remove the thumbs on mobile pages
    if(mobileThumbs){
        document.querySelector('ol.flickity-page-dots').style.display = 'none';
    }
};

// Start the initialization
initializeScript();
